// import './UserWithdrawHistry.css';
import React, { useState, useEffect } from "react";
import "./Staking.css";
import {

    Box,
    Button,



    Grid2
} from







    "@mui/material";
import Header from "../Header/Header";
import Pagination from "@mui/material/Pagination";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import consts from "../../constant";
import Axios from "axios";


import { useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer } from "react-toastify";
import usercalls from "../../Axios";


import Dialog from "@mui/material/Dialog";



import { styled, useTheme } from "@mui/material/styles";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

const drawerWidth = 260;





const StackingBanner = () => {

    const Navigate = useNavigate();


    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));



    const [limit] = useState(10);
    const [page, setPage] = useState(1);
    const [setloader] = useState(false);
    const path = usercalls();
    const [setData] = useState([]);

    const [totalPage, setTotalPage] = useState(0);



    const getPairs = async () => {
        const url = `${consts.BackendUrl}/`;

        Axios.get(url).
            then((response) => {
                setData(response?.data);
                setloader(false);
                setTotalPage(Math.ceil(response?.data.length / limit));
            }).
            catch((error) => {
                console.error("Error fetching data:", error);
            });
    };
    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getPairs();
        } else {
            Navigate(`/${consts.route + "/login"}`);
        }
    }, []);



    const [getUserList, setGetUserList] = useState([]);

    console.log(getUserList, 'getUserList');

    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);



    const getAlUser = async () => {
        try {
            const url = `${consts.BackendUrl}/admin/getstakingplan`;

            const response = await path.postCall({ url });
            const result = await response.json();
            console.log(result, 'result');
            if (result?.success) {
                setGetUserList(result?.result);
            }
        } catch (error) {
            console.log("🚀 ~ getAlUser ~ error", error);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getAlUser();
        } else {
            Navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page]);



    const formatDate = (dateString) => {
        if (!dateString) return "N/A"; // Handle null or undefined dates
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit"
        });


    };






    return (
        <div className="Asset">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />

                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}>

                    <div style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        height: "50px",
                        width: "100%",
                        padding: "10px"
                    }}>

                        <Button
                            variant="contained"
                            style={{
                                color: "black",
                                backgroundColor: "lightblue",
                                fontWeight: "bold",
                                width: "200px",
                                height: "40px",
                                marginRight: "20px"
                            }}


                            onClick={() => {
                                Navigate(`/${consts.route}/createBanner`);
                            }}>
                            Create Banner
                        </Button>
                    </div>



                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div className="custom_table">
                            <TableContainer>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                "S.NO", "PlanName", "Commsion", "Start Date", "End Date", "Description", "Status", " Action"].
                                                map((header) =>
                                                    <TableCell key={header} align="center" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                                                        {header}
                                                    </TableCell>)}

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getUserList.
                                            slice((page - 1) * limit, page * limit).
                                            map((value, index) =>
                                                <TableRow key={index}>
                                                    <TableCell align="center">{limit * (page - 1) + index + 1}</TableCell>
                                                    {/* <TableCell align="center">
                                                        {value?.type === "loss" ?
                                                            <>
                                                                <div style={{ display: "flex", alignItems: "center" }} className=''>
                                                                    <ArrowDownward style={{ color: "red", marginRight: 5 }} />
                                                                    <h3>Loss</h3>
                                                                </div>

                                                            </> :
                                                            value?.type === "profit" ?
                                                                <>
                                                                    <div style={{ display: "flex", alignItems: "center" }} className=''>
                                                                        <ArrowUpward style={{ color: "green", marginRight: 5 }} />
                                                                        <h3>Profit</h3>
                                                                    </div>
                                                                </> :
                                                                value?.type
                                                        }
                                                    </TableCell> */}
                                                    <TableCell align="center">{value?.planName}</TableCell>
                                                    <TableCell align="center">{value?.commission}</TableCell>
                                                    <TableCell align="center">{formatDate(value?.startTime)}</TableCell>
                                                    <TableCell align="center">{formatDate(value?.endTime)}</TableCell>
                                                    <TableCell align="center">{value?.description}</TableCell>
                                                    <TableCell align="center">{value?.status == true ? "Active" : "In active"}</TableCell>
                                                    {/* <TableCell align="center">{formatDate(value?.createdAt)}</TableCell> */}
                                                    <TableCell align="center">
                                                        {/*  edit button */}
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                color: "black",
                                                                backgroundColor: "lightblue",
                                                                fontWeight: "bold",
                                                                width: "150px",
                                                                height: "40px"
                                                            }}
                                                            onClick={() => {
                                                                Navigate(`/${consts?.route}/editBanner`, {
                                                                    state: {
                                                                        value
                                                                    }
                                                                });
                                                            }}>
                                                            Edit
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>)}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Pagination
                                className='pagination'
                                count={totalPage}
                                page={page}
                                onChange={(event, value) => setPage(value)}
                                variant="outlined"
                                shape="rounded"
                                sx={{ display: "flex", justifyContent: "center", mt: 2 }} />
                        </div>
                    </Grid2>

                </Box>

            </Box>
        </div>);

};

export default StackingBanner;